import { useRef, useState, useEffect } from "react";
import PopupWrapper from "./PopupWrapper";

export default function ColorPopup({
  color,
  onChange,
}) {
  const inputRef = useRef(null);
  const [recentColors, setRecentColors] = useState([]);

  const lastColorRef = useRef(color);


  function normalizeHex(color) {
    if (!color) return "#ffffff";
  
    // already valid 6-digit hex
    if (/^#[0-9A-Fa-f]{6}$/.test(color)) return color;
  
    // convert #rgb → #rrggbb
    if (/^#[0-9A-Fa-f]{3}$/.test(color)) {
      return (
        "#" +
        color
          .substring(1)
          .split("")
          .map((c) => c + c)
          .join("")
      );
    }
  
    return "#ffffff"; // fallback safety
  }

  let safeColor = normalizeHex(color);

  function updateRecent() {
    console.log("Updating Recent");
  
    const latest = lastColorRef.current;
  
    if (!latest) return;
  
    // ALWAYS read latest from localStorage
    const stored =
      JSON.parse(localStorage.getItem("recentColors")) || [];
  
    const newList = [
      latest,
      ...stored.filter((c) => c !== latest),
    ].slice(0, 10);
  
    setRecentColors(newList);
  
    localStorage.setItem(
      "recentColors",
      JSON.stringify(newList)
    );
  }


  function loadRecent() {
    try {
      const stored =
        JSON.parse(localStorage.getItem("recentColors")) || [];
  
      const current = normalizeHex(color);
  
      const merged = [
        current,
        ...stored.filter((c) => c !== current),
      ].slice(0, 10);
  
      setRecentColors(merged);
  
      // persist immediately so it is never lost
      localStorage.setItem(
        "recentColors",
        JSON.stringify(merged)
      );
  
    } catch (err) {
      console.error("Failed parsing recent colors");
    }
  }
  
  
  return (
    <PopupWrapper

    onOpen={() => {        
        loadRecent();
        
      }}

      onClose={() => {        
        updateRecent();
        
      }}

      trigger={
        <div
          style={{
            width: 36,
            height: 36,
            borderRadius: 6,
            border: "1px solid #ccc",
            background: safeColor,
            cursor: "pointer",
          }}
        />
      }
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: 10,
          minWidth: 160,
        }}
      >
        <button
          type="button"
          onMouseDown={(e) => {
            e.preventDefault();
            inputRef.current?.click();            
          }}
        >
          Choose custom color
        </button>

        <input
          ref={inputRef}
          type="color"
          style={{
            position: "absolute",
            opacity: 0,
            width: 0,
            height: 0,
          }}
          value={safeColor}
          onChange={(e) => {
            const newColor = e.target.value;
            lastColorRef.current = newColor;
            onChange(newColor);
          }}
        />


        <div style={{ display: "flex", gap: 6, flexWrap: "wrap" }}>
          {recentColors.map((c) => (
            <div
              key={c}
              onClick={() => {                
                lastColorRef.current = c;
                onChange(c);
              }}
              style={{
                width: 18,
                height: 18,
                borderRadius: 4,
                background: c,
                cursor: "pointer",
                border:
                  color === c
                    ? "2px solid black"
                    : "1px solid rgba(0,0,0,0.15)",
              }}
            />
          ))}
        </div>
      </div>
    </PopupWrapper>
  );
}

